import React from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { Tabs, Row, Col, Button, Tooltip } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import styled from '@emotion/styled'

const { TabPane } = Tabs

const DiscountTabs = (props: any) => {
  const { codes, automatic, loyalty } = props
  const navigate = useNavigate()
  const location = useLocation()

  const getActiveKey = () => {
    if (location.pathname === '/discounts') return 'manual'
    const pathArray = location.pathname.split('/')
    return pathArray[pathArray.length - 1]
  }

  const handleTabChange = (key: string) => {
    navigate(`/discounts/${key}`)
  }

  return (
    <>
      <FullWidthRow justify='end'>
        <Col>
          <Link to={'/discounts/create'}>
            <Button icon={<PlusOutlined />}>Add Discount</Button>
          </Link>
        </Col>
      </FullWidthRow>
      <Tabs
        type='card'
        activeKey={getActiveKey()}
        onChange={handleTabChange}
        className='_mb-8'
      >
        <TabPane
          key='manual'
          tab={
            <Tooltip
              title={
                <span>
                  <a
                    href='https://support.slerp.com/knowledge/creating-and-managing-discount-codes'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    Here's our best practise guide
                  </a>{' '}
                  to creating and managing discount codes.
                </span>
              }
            >
              <span data-testid='discount-codes-tab-pane'>
                Manual Discounts
              </span>
            </Tooltip>
          }
        >
          {codes}
        </TabPane>

        <TabPane
          key='automatic'
          tab={
            <span data-testid='automatic-discounts-tab-pane'>
              Automatic Discounts
            </span>
          }
        >
          {automatic}
        </TabPane>

        <TabPane
          key='rewards'
          tab={
            <span data-testid='loyalty-rewards-tab-pane'>Loyalty Rewards</span>
          }
        >
          {loyalty}
        </TabPane>
      </Tabs>
    </>
  )
}

const FullWidthRow = styled(Row)`
  width: 100%;
`

export default DiscountTabs
